module.exports = __webpack_public_path__ + "static/media/62127775.705eefd1.jpeg";